import useArrayMutation from "@/hooks/useArrayMutation";
import useFetch, { FetchResponse } from "@/hooks/useFetch";
import client from "@/utils/api/client";
import {
  PostResponse,
  ProductVariationWithProductResponse,
  ProjectResponse,
  SearchIndexResponse,
} from "@/web-client/api";
import { useCallback } from "react";

export type MutateItems = (
  key: "building_materials" | "interiors" | "projects" | "posts",
  updated: ProductVariationWithProductResponse | ProjectResponse | PostResponse,
) => void;

type SearchIndex = {
  response: FetchResponse<SearchIndexResponse>;
  mutate: MutateItems;
};

const useSearchIndex = (keyword: string, waitForAuth: boolean): SearchIndex => {
  const { update } = useArrayMutation();

  const response = useFetch<SearchIndexResponse>(
    `/search?keyword=${keyword}`,
    async () => {
      const { data } = await client.searchGet({ keyword: keyword as string });

      return data;
    },
    null,
    { waitForAuth },
  );

  const mutateItems = useCallback<MutateItems>(
    (
      key,
      updated:
        | ProductVariationWithProductResponse
        | ProjectResponse
        | PostResponse,
    ) => {
      const { data, mutate } = response;
      const copy = data[key].slice();
      const updates = update(copy, updated);

      const updatedData = { ...data, [key]: updates };
      mutate(updatedData, false); // validateすると、重いapiを再度叩くのでfalseにしておく
    },
    [update, response],
  );

  return {
    response,
    mutate: mutateItems,
  };
};
export default useSearchIndex;
